module.exports = __webpack_public_path__ + "detail3.4c6274a8.jpg";